/**
 * Import React libraries.
 */
import * as React from 'react';

/**
 * Import custom components.
 */
import {SystemIcons as icons} from '../icons/index';
import {Size} from '../types';
/**
 * Import custom styles.
 */
import {ChipContainer, ChipContent, ChipContentContainer} from './ChipStyles';

/**
 * Import custom types.
 */
import {ActionChipProps} from './ChipTypes';
import {defaultOnMouseDownHandler} from '../common';

const ActionChip: React.FunctionComponent<ActionChipProps> = ({
                                                                icon,
                                                                text,
                                                                size = Size.Medium,
                                                                disabled,
                                                                onClick,
                                                                className,
                                                                dataTestId,
                                                                ...rest
                                                              }: ActionChipProps) => {

  /**
   * Return Action Chip component.
   */
  return (
    <ChipContainer className={`${size} ${disabled ? 'disabled' : ''} outline ${!!onClick ? 'interactive' : ''} ${className || ''}`}
                   
                   onClick={() => !disabled && onClick && onClick()}
                   onMouseDown={defaultOnMouseDownHandler}
                   data-testid={dataTestId}
                   role="button"
                   onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && !disabled && onClick && onClick()}
                   tabIndex={disabled || !onClick ? -1 : 0}
                   {...rest}>
      <ChipContentContainer>
        <ChipContent>
          {
            icon &&
            <div className={'chip-icon icon-left'}>
              {icon}
            </div>
          }
          <div>
            {text}
          </div>
        </ChipContent>
      </ChipContentContainer>
    </ChipContainer>
  );
};

export default ActionChip;
